import { render, staticRenderFns } from "./GroupsDataTable.vue?vue&type=template&id=2ec21a6a&scoped=true"
import script from "./GroupsDataTable.vue?vue&type=script&lang=js"
export * from "./GroupsDataTable.vue?vue&type=script&lang=js"
import style0 from "./GroupsDataTable.vue?vue&type=style&index=0&id=2ec21a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec21a6a",
  null
  
)

export default component.exports